function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconUsers = function SvgIconUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.98438C9.37665 1.98438 7.25 4.11102 7.25 6.73438C7.25 9.35773 9.37665 11.4844 12 11.4844C14.6234 11.4844 16.75 9.35773 16.75 6.73438C16.75 4.11102 14.6234 1.98438 12 1.98438ZM8.75 6.73438C8.75 4.93945 10.2051 3.48438 12 3.48438C13.7949 3.48438 15.25 4.93945 15.25 6.73438C15.25 8.5293 13.7949 9.98438 12 9.98438C10.2051 9.98438 8.75 8.5293 8.75 6.73438Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.9844C9.96067 12.9844 8.07752 13.4551 6.67815 14.2548C5.3 15.0423 4.25 16.2445 4.25 17.7344C4.25 19.2242 5.3 20.4265 6.67815 21.214C8.07752 22.0136 9.96067 22.4844 12 22.4844C14.0393 22.4844 15.9225 22.0136 17.3219 21.214C18.7 20.4265 19.75 19.2242 19.75 17.7344C19.75 16.2445 18.7 15.0423 17.3219 14.2548C15.9225 13.4551 14.0393 12.9844 12 12.9844ZM5.75 17.7344C5.75 17.0151 6.26701 16.2173 7.42236 15.5571C8.55649 14.9091 10.1733 14.4844 12 14.4844C13.8267 14.4844 15.4435 14.9091 16.5776 15.5571C17.733 16.2173 18.25 17.0151 18.25 17.7344C18.25 18.4536 17.733 19.2514 16.5776 19.9116C15.4435 20.5597 13.8267 20.9844 12 20.9844C10.1733 20.9844 8.55649 20.5597 7.42236 19.9116C6.26701 19.2514 5.75 18.4536 5.75 17.7344Z"
  }));
};
export default SvgIconUsers;